<template>
    <b-navbar toggleable="md" type="light" variant="light">

        <b-navbar-toggle target="nav_collapse"></b-navbar-toggle>

        <b-navbar-brand to="/gallery/Fotografin/0"> <img style="position: relative;height:90px;margin-right: -15px;margin-top: -15px; margin-bottom: -35px" src="@/assets/img/dankeskarte.png"></b-navbar-brand>

        <b-collapse is-nav id="nav_collapse">
          <b-navbar-nav>
            <b-nav-item v-if="isLoggedIn" to="/gallery/Fotografin/0">Fotos der Fotografin</b-nav-item>
            <b-nav-item v-if="isLoggedIn" to="/gallery/Guests/0">Fotos von Gästen</b-nav-item>
            <b-nav-item v-if="isLoggedIn" to="/preupload">Upload</b-nav-item>
          </b-navbar-nav>

          <!-- Right aligned nav items -->
          <b-navbar-nav v-if="isLoggedIn" class="ml-auto">
              <b-nav-item v-if="isBigGallery" @click="downloadAll" v-b-popover.hover="'Aktuelle Galerie herunterladen'">
                <img src="@/assets/img/herunterladen-96.png" height="24px">
              </b-nav-item>
              <b-nav-item v-if="isSmallGallery" @click="downloadAll" >
                Aktuelle Galerie herunterladen
              </b-nav-item>
              <b-nav-item v-if="isAdmin" to="admin">Admin</b-nav-item>
              <b-nav-item to="/help">Hilfe</b-nav-item>
              <b-nav-item @click="logout">Logout</b-nav-item>
          </b-navbar-nav>

          <b-navbar-nav v-if="!isLoggedIn" class="ml-auto">
              <b-nav-item to="/impressum">Impressum & Datenschutz</b-nav-item>
            <b-nav-item to="/login">Login</b-nav-item>
          </b-navbar-nav>
        </b-collapse>
      </b-navbar>
</template>

<script>
import firebase from 'firebase/app'
import {getBootstrapBreakpoint} from '@/utils/utils.js'

export default {
  name: 'Header',
  created: function () {
    const self = this
    firebase.auth().onAuthStateChanged(function (user) {
      self.isAdmin = false
      self.currentUser = user
    })
  },
  data: function () {
    return {
      currentUser: '',
      upHere: false,
      isAdmin: false
    }
  },
  methods: {
    logout: function () {
      firebase.auth().signOut().then(() => {
        this.$router.replace('login')
      })
    },
    downloadAll: function () {
      if (this.$route.params.gal === 'Fotografin') {
        this.$ga.event({eventCategory: 'all dowloaded', eventAction: 'maingallery', eventLabel: 'maingallery - downloaded'})
        window.location = '/static/upload/downloadAll.php?galleryname=fotografin'
      } else if (this.$route.params.gal === 'Guests') {
        this.$ga.event({eventCategory: 'all dowloaded', eventAction: 'guestgallery', eventLabel: 'guestgallery - downloaded'})
        window.location = '/static/upload/downloadAll.php'
      }
    }
  },
  computed: {
    isLoggedIn: function () {
      // currentUser = firebase.auth().currentUser
      if (this.currentUser != null) {
        return true
      } else {
        return false
      }
    },
    getBootstrapBreakpointFn: function () {
      return getBootstrapBreakpoint()
    },
    isBigGallery: function () {
      return (this.getBootstrapBreakpointFn === 'sm' || this.getBootstrapBreakpointFn === 'md' || this.getBootstrapBreakpointFn === 'lg') && (this.$route.params.gal === 'Fotografin' || this.$route.params.gal === 'Guests')
    },
    isSmallGallery: function () {
      return (!this.isBigGallery) && (this.$route.params.gal === 'Fotografin' || this.$route.params.gal === 'Guests')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Header.vue